import { render, staticRenderFns } from "./ListAbsence.vue?vue&type=template&id=135d3d0f&scoped=true&"
import script from "./ListAbsence.vue?vue&type=script&lang=js&"
export * from "./ListAbsence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d3d0f",
  null
  
)

export default component.exports